import React from 'react'

function ExploreAction() {
  return (
    <div>
          <section className="call-to-action">
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <h2>Looking to Work On A Project ?</h2>
                </div>
                <div className="col-lg-4">
                    <div className="white-button">
                        <a href="#">Contact Us Now</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default ExploreAction
